module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<nav>\n    <ul class="nav nav-pills nav-stacked">\n    </ul>\n</nav>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./js/ui/navPillsStacked/list.ejs
// module id = 360
// module chunks = 3